export default __webpack_public_path__ + "static/media/gino_resume.937ae19b.pdf";